export enum ScoringFormulaCodes {
    totalScore = 'TS',
    sectionScore = 'SS',
    questionScore = 'QS',
}

export enum ScoringFormulaNames {
    totalScore = 'Total score',
    sectionScore = 'Section score',
    questionScore = 'Question score',
}
